import { CartLineUpdateInput } from '../types';
import { CartPolicy } from './types';
import { getAttr, pass } from './cartLineHelpers';

export const bundleQuantityMirrorPolicy: CartPolicy = (input, cart) => {
  const modifications = input.lineItemsToModify;
  if (!modifications?.length || !cart) return pass(input);

  const lineById = new Map(cart.lines.edges.map((edge) => [edge.node.id, edge.node]));
  const parentQtyByBundle = new Map<string, number>();

  for (const entry of modifications) {
    if (typeof entry.quantity !== 'number') continue;

    const parent = lineById.get(entry.id);
    const bundleId = getAttr(parent?.attributes, '_bundle_id');
    const isParent = getAttr(parent?.attributes, '_is_bundle_parent') === '1';
    if (!isParent || !bundleId || parentQtyByBundle.has(bundleId)) continue;

    parentQtyByBundle.set(bundleId, entry.quantity);
  }

  if (parentQtyByBundle.size === 0) return pass(input);

  const alreadyModifying = new Set(modifications.map((line) => line.id));
  const extra: CartLineUpdateInput[] = [];

  for (const { node } of cart.lines.edges) {
    const bundleId = getAttr(node.attributes, '_bundle_id');
    const quantity = bundleId ? parentQtyByBundle.get(bundleId) : undefined;
    if (quantity === undefined) continue;
    if (getAttr(node.attributes, '_mirror_parent_qty') !== '1') continue;
    if (alreadyModifying.has(node.id)) continue;

    alreadyModifying.add(node.id);
    extra.push({
      id: node.id,
      quantity,
      attributes: node.attributes,
    });
  }

  if (extra.length === 0) return pass(input);

  return {
    input: { ...input, lineItemsToModify: [...modifications, ...extra] },
    reasons: ['bundle parent quantity mirrors to marked children'],
  };
};
